import { DialogContent } from "@mui/material";
import DialogHESP from "../DialogHESP/DialogHESP";

import { toast } from "react-toastify";
import { v4 } from "uuid";
import { GetDatacenter_datacenter } from "../../views/App/__generated__/GetDatacenter";
import TLAManageDatacenterForm from "./TLAManageDatacenterForm";

interface Props {
    id: string;
    open: boolean;
    onClose: () => void;
    datacenter: GetDatacenter_datacenter;
}

export default function TLAUpdateDatacenterInfoDialog({ id, datacenter, open, onClose }: Props) {
    return (
        <DialogHESP
            title="Update datacenter"
            onClose={onClose}
            open={open}
            content={
                <>
                    <DialogContent>
                        <TLAManageDatacenterForm
                            id={id}
                            values={{
                                id: datacenter.id,
                                name: datacenter.name,
                                tlaCertificates: datacenter.tla.certificates
                                    ? datacenter.tla.certificates.map((cert) => ({ ...cert, id: v4() }))
                                    : [],
                                tlaDescription: datacenter.tla.description,
                                tlaDomain: datacenter.tla.domain ?? "",
                                tlaHostId: datacenter.tla.hostId ?? "",
                                tlaHttp3: datacenter.tla.http3 === true,
                                tlaLetsEncrypt: datacenter.tla.letsEncrypt === true,
                                tlaName: datacenter.tla.name,
                                tlaOverride: datacenter.tla.override ?? "",
                                tlaProvider: datacenter.tla.provider ?? "",
                                tlaRegion: datacenter.tla.region ?? "",
                                tlaTls: datacenter.tla.tls === true,
                                fqdn: datacenter.tla.fqdn ?? undefined,
                                labels: datacenter.tla.labels,
                            }}
                            onUpdateSuccess={() => {
                                toast.success("Updated datacenter");
                                onClose();
                            }}
                        />
                    </DialogContent>
                </>
            }
        />
    );
}
